export default __webpack_public_path__ + "static/media/lock_v3.a1b20e13.svg";